import randomId from "../common/randomId";
import { Dashboard, Home, Login, Partners } from "../views";
import FAQ from "../views/FAQ/FAQ";
import PartnerLegal from "../views/Partners/PartnerLegal";
import PrivacyPolicy from "../views/PrivacyPolicy/PrivacyPolicy";
import Support from "../views/Support/Support";
import Terms from "../views/Terms/Terms";

const viewsUrls: any[] = [
    {
        id: randomId(),
        path: "/",
        exact: true,
        component: Home,
        type: "public"
    },
    {
        id: randomId(),
        path: "/partners",
        exact: true,
        component: Partners,
        type: "public"
    },
    {
        id: randomId(),
        path: "/support",
        exact: true,
        component: Support,
        type: "public"
    },
    {
        id: randomId(),
        path: "/privacy",
        exact: true,
        component: PrivacyPolicy,
        type: "public"
    },
    {
        id: randomId(),
        path: "/terms",
        exact: true,
        component: Terms,
        type: "public"
    },
    {
        id: randomId(),
        path: "/faq",
        exact: true,
        component: FAQ,
        type: "public"
    },
    {
        id: randomId(),
        path: "/partners/legal",
        exact: true,
        component: PartnerLegal,
        type: "public"
    },
];

export default viewsUrls;